import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRealtimeParticipants } from '../../hooks/useRealtime'
import { LowerThird } from '../../components/overlay/LowerThird'

export function LowerThirdPage() {
  const [searchParams] = useSearchParams()
  const raceId = searchParams.get('race') || ''
  const [leader, setLeader] = useState<any>(null)

  const { participants } = useRealtimeParticipants(raceId)

  useEffect(() => {
    if (participants.length === 0) return
    const firstPlace = participants.find((p) => p.current_position === 1)
    if (firstPlace) setLeader(firstPlace)
  }, [participants])

  if (!leader) {
    return <div className="w-full h-screen bg-transparent" />
  }

  return (
    <div className="w-full h-screen bg-transparent">
      <LowerThird
        title={leader.pilot_name}
        subtitle={`Boat #${leader.boat_number}`}
        boatNumber={leader.boat_number}
        boatColor={leader.boat_color}
        highlight="LEADING"
      />
    </div>
  )
}
